import api from '../api/works-api';

export default {
    getWorksById(id) {
        return new Promise((resolve, reject) => {
            api.getWorksById(id).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        })
    },
    getWorksList(param) {
        return new Promise((resolve, reject) => {
            api.getWorksList(param).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        })
    },

    setWorkTags (pid, param) {
        return new Promise((resolve, reject) => {
            api.setWorkTags(pid, param).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        })
    },

    deleteWorks(param) {
        return new Promise((resolve, reject) => {
            api.deleteWorks(param).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },

    saveWorks(param, status, syncUpdateCover, screenshotByCanvas) {
        return new Promise((resolve, reject) => {
            api.saveWorks(param, status, syncUpdateCover, screenshotByCanvas).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            }).catch(e => {
                reject(e)
            })
        });
    },

    exportWork(param) {
        return new Promise((resolve, reject) => {
            api.exportWork(param).then((response) => {
                if (response.data.type.indexOf('application/octet-stream') > -1) {
                    resolve(response || {});
                } else {
                    reject(response);
                }
            });
        });
    },
    exportWorks(param, imgType) {
        return new Promise((resolve, reject) => {
            api.exportWorks(param, imgType).then((response) => {
                if (response.data.type.indexOf('application/octet-stream') > -1) {
                    resolve(response || {});
                } else {
                    reject(response);
                }
            });
        });
    },
    exportPPT (projectId, workId, url) {
        return new Promise((resolve, reject) => {
            api.exportPPT(projectId, workId, url).then((response) => {
                if (response.data.type.indexOf('application/octet-stream') > -1) {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
        });
    },
    getWorksSize (pid) {
        return new Promise((resolve, reject) => {
            api.getWorksSize(pid).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    getWorkTagList (pid) {
        return new Promise((resolve, reject) => {
            api.getWorkTagList(pid).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        })
    },
    getWorkTags (pid) {
        return new Promise((resolve, reject) => {
            api.getWorkTags(pid).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        })
    },
    copyWorks (param) {
        return new Promise((resolve, reject) => {
            api.copyWorks(param).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    getProjectAdmin (pid) {
        return new Promise((resolve, reject) => {
            api.getProjectAdmin(pid).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    rename (param) {
        return new Promise((resolve, reject) => {
            api.rename(param).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    multiSliceExport (id, projectId, imgSuffix) {
      return new Promise((resolve, reject) => {
          api.multiSliceExport(id, projectId, imgSuffix).then((response) => {
              if (response.data.type.indexOf('application/octet-stream') > -1) {
                  resolve(response);
              } else {
                  reject(response);
              }
          });
      });
    },
    exportPart (projectId, workId, templateId, templateOnlyId) {
        return new Promise((resolve, reject) => {
            api.exportPart(projectId, workId, templateId, templateOnlyId).then((response) => {
                if (response.data.type.indexOf('application/octet-stream') > -1) {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
        });
    },
}